import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import { handleRest } from '../../h2Api'
import {
  COURSE_SCHEDULE_INITIAL_RESULTS,
  COURSE_SCHEDULE_RESULTS,
  COURSE_SEARCH_RESULTS,
  COURSE_SELECT_FOR_VIEW,
  COURSE_SET_GRADE,
  CREATE_NOTE,
  REPORT_DATA_SAVE_PORTFOLIO,
  REPORT_DATA_SAVE_PORTFOLIO_DISMISS,
  SAVE_NOTE,
  SELECT_GRADE_SUBJECT,
  TOGGLE_COLUMN_WIDTH,
  TOGGLE_EDIT_MODAL,
  TOGGLE_STANDARD,
  TOGGLE_VALIDATION_DESCRIPTION,
  TUTORIAL_ACKNOWLEDGE
} from '../../actions/planning/courseplanner'

const initialSavedConfirm = {
  visible: false,
  forUser: null
}
const initialState = {
  editModalOpen: false,
  validationDescriptionOpen: false,
  selectedStandard: null,
  grades: [7, 8, 9, 10, 11, 12],
  addition: {
    subjectArea: null,
    gradeLevel: null,
    courseSearchResults: handleRest(null, { result: [] })
  },
  user: {
    graduationYear: null,
    gradeLevel: null
  },
  currentGradeIsFocus: false,
  myClasses: [],
  details: {},
  selectedCourse: null,
  showSavedConfirm: initialSavedConfirm
}
const initialNoteForm = {
  note: '',
  courseId: null
}
const data = (state = initialState, action) => {
  switch (action.type) {
    case REPORT_DATA_SAVE_PORTFOLIO_DISMISS:
      return {
        ...state,
        showSavedConfirm: initialSavedConfirm
      }

    case REPORT_DATA_SAVE_PORTFOLIO:
      return {
        ...state,
        showSavedConfirm: {
          visible: true,
          forUser: action.user
        }
      }
    case COURSE_SCHEDULE_INITIAL_RESULTS:
      const rst = handleRest(action)
      const usr = (rst.result && rst.result.details && rst.result.details.user) || {}
      const st = {
        ...state,
        ...(rst.result || {})
      }

      return st

    case TOGGLE_VALIDATION_DESCRIPTION:
      return {
        ...state,
        validationDescriptionOpen: !state.validationDescriptionOpen
      }

    case TUTORIAL_ACKNOWLEDGE:
      return {
        ...state,
        details: {
          ...state.details,
          sawTutorial: true
        }
      }

    case COURSE_SCHEDULE_RESULTS:
      const rst2 = handleRest(action)

      console.log(rst2)

      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          myClasses: rst2.result
        }
      }

      return state

    case COURSE_SET_GRADE:
      return {
        ...state,
        currentGradeIsFocus: false
      }

    case COURSE_SELECT_FOR_VIEW:
      return {
        ...state,
        selectedCourse: action.scheduledCourse
      }

    case COURSE_SEARCH_RESULTS:
      return {
        ...state,
        addition: {
          ...state.addition,
          courseSearchResults: {
            ...handleRest(action)
          }
        }
      }

    case SELECT_GRADE_SUBJECT:
      return {
        ...state,
        addition: {
          ...state.addition,
          gradeLevel: action.gradeLevel,
          subjectArea: action.subjectArea
        }
      }

    case TOGGLE_EDIT_MODAL:
      return {
        ...state,
        editModalOpen: action.visible
      }

    case TOGGLE_STANDARD:
      return {
        ...state,
        selectedStandard: action.standard
      }

    case TOGGLE_COLUMN_WIDTH:
      return {
        ...state,
        currentGradeIsFocus: action.state
      }

    case CREATE_NOTE:
      return {
        ...state,
        details: {
          ...state.details,
          notes: [...state.details.notes, action.note]
        }
      }

    default:
      return state
  }
}

export default combineReducers({
  data,
  coursePlannerRequest: h2Api.restReducer(COURSE_SCHEDULE_INITIAL_RESULTS),
  noteSaveRequest: h2Api.restReducer(SAVE_NOTE),
  noteForm: modelReducer('planning.courseplanner.noteForm', initialNoteForm),
  forms: formReducer('planning.courseplanner', {
    noteForm: initialNoteForm
  })
})
